import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const NavTabs: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = ['/', '/ask-dr-bill', '/benefits-concierge', '/account'];
  const currentIndex = tabs.indexOf(location.pathname);
  const [value, setValue] = React.useState(currentIndex === -1 ? 0 : currentIndex);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    navigate(tabs[newValue]);
  };

  return (
    <Paper
      elevation={12}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: '8vh' // total height
      }}
    >
      <BottomNavigation
        value={value}
        onChange={handleChange}
        showLabels
        sx={{
          // Force the navigation to fill our 8vh height
          height: '100%',
          display: 'flex',
          alignItems: 'center',  // vertical center
          justifyContent: 'space-around',
          // For the icon and label sizes:
          '& .MuiSvgIcon-root': {
            fontSize: '4vh' // icon size
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '1.5vh', // label size
            lineHeight: 1.2,
            marginTop: '2px'
          }
        }}
      >
        <BottomNavigationAction label="Home" icon={<HomeIcon />} />
        <BottomNavigationAction label="Dr Bill" icon={<MedicalServicesIcon />} />
        <BottomNavigationAction label="Concierge" icon={<VolunteerActivismIcon />} />
        <BottomNavigationAction label="Account" icon={<AccountCircleIcon />} />
      </BottomNavigation>
    </Paper>
  );
};

export default NavTabs;
